import React from 'react';
import { IdeaGalaxy } from '../../components/idea-machine/IdeaGalaxy';

export default function IdeaGalaxyPage() {
  return (
    <div className="h-full w-full overflow-hidden relative">
      <IdeaGalaxy isPageMode={true} />
    </div>
  );
}
